<div class="custom-grid">
  @for (tile of tiles; track $index) {
    <div class="grid-item" [style.grid-column]="tile.cols"
      [style.background]="debug ? tile.color: 'transparent'">
      <ng-container *ngTemplateOutlet="tile.tpl"></ng-container>
    </div>
  }
</div>

<ng-template #headerTemplate>
  <div>
    <pub-domain-breadcrumbs (selectDomains)="selectDomains($event)"
    [path]="concept?.domainPaths?.[0]"></pub-domain-breadcrumbs>
  </div>
</ng-template>

<ng-template #leftTemplate>
  @if (concept) {
    <div>
      <pub-image-gallery [entryId]="concept.id" [fileIds]="fileIds"></pub-image-gallery>
    </div>
  }
</ng-template>

<ng-template #rightTemplate>
  @if (concept) {
    <div [ngClass]="cssClassName">
      <div [class.feedback-target]="feedbackMode.isActive"
           (click)="onTermClick(getTerm()!, $event)">
        <pub-term-render [term]="getTerm()" [focus]="true"
                         (conceptSelected)="selectConcept($event)"></pub-term-render>
      </div>
      <hr/>
      <div [class.feedback-target]="feedbackMode.isActive"
           (click)="onConceptSectionClick($event)">
        @if (classificationFields?.length) {
          <div class="fset ccl">
            @for (field of classificationFields; track field.oid) {
              <div pub-field-render [field]="field"
                   (conceptSelected)="selectConcept($event)"></div>
            }
          </div>
        }
        @if (conceptFields?.length) {
          <div class="fset cl">
            @for (field of conceptFields; track field.oid) {
              <div pub-field-render [field]="field"
                   (conceptSelected)="selectConcept($event)"></div>
            }
          </div>
        }
      </div>
      <hr/>
      <pub-render-relations [conceptId]="concept.id" (conceptSelected)="selectConcept($event)"></pub-render-relations>
    </div>
  }
</ng-template>
